import styled from 'styled-components';
import { Checkbox } from '@app/components/common/Checkbox/Checkbox';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const ContentQuestion = styled.div`
  margin-bottom: 24px;
`;

export const CheckboxStyle = styled(Checkbox)`
  display: flex;
  gap: 8px;
  color: #333;
`;
